import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, viewChild } from '@angular/core';
import { WjFlexGrid, WjGridModule } from '@mescius/wijmo.angular2.grid';
import { CellType } from '@mescius/wijmo.grid';
import { ColumnPicker } from '../lib/ColumnPicker';
import { WjGridFilterModule } from '@mescius/wijmo.angular2.grid.filter';
import { WjGridSearchModule } from '@mescius/wijmo.angular2.grid.search';
import { ExcelUtils } from '../lib/Excel';

const QuotedSheetFormulaRegex = /^='([^']*)'!.*/;
const UnquotedSheetFormulaRegex = /^=([^'][^!]*)!.*/;

function guessSheetFromFormula(formula) {
    return QuotedSheetFormulaRegex.exec(formula)?.[1] || UnquotedSheetFormulaRegex.exec(formula)?.[1];
}

@Component({
    selector: 'app-ranges-list',
    templateUrl: './ranges-list.component.html',
    styleUrls: ['./ranges-list.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjGridModule,
        WjGridFilterModule,
        WjGridSearchModule
    ],
    standalone: true
})
export class RangesListComponent implements AfterViewInit {

    names: Excel.NamedItem[] = [];

    grid = viewChild.required<WjFlexGrid>('grid');
    // @ViewChild('columnPicker') columnPicker!: WjListBox;

    constructor(private el: ElementRef<HTMLElement>) { }

    async ngAfterViewInit(): Promise<void> {
        await this.listNames();
        ColumnPicker.createColumnPicker(this.el.nativeElement, this.grid());
    }

    async listNames() {
        try {
            await Excel.run(async context => {
                context.workbook.names.load();
                await context.sync();
                this.names = context.workbook.names.items;
                this.names.forEach(name => {
                    const formula = name.formula;
                    name['sheet'] = guessSheetFromFormula(formula);
                });
                this.grid().itemsSource = this.names;
            });
        } catch (error) {
            console.error(error);
        }
    }

    async showRange() {
        const ni = this.grid().selectedRows[0]?.dataItem as Excel.NamedItem;
        if (ni.type === Excel.NamedItemType.range) {
            await ExcelUtils.run(async ctx => {
                const namedItem = ctx.workbook.names.getItem(ni.name);
                const range = namedItem.getRangeOrNullObject();
                range.load('worksheet/name,isNullObject');
                await ctx.sync();

                if (!range.isNullObject) {
                    const worksheet = ctx.workbook.worksheets.getItem(range.worksheet.name);
                    worksheet.visibility = Excel.SheetVisibility.visible;
                    worksheet.activate();
                    range.select();
                }
            });
        }
    }

    onGridContextMenu(e: MouseEvent) {
        e.preventDefault();
        const ht = this.grid().hitTest(e.pageX, e.pageY);
        switch (ht.cellType) {
            case CellType.Cell:
            case CellType.RowHeader:
                // this.rowContextMenu.show(this.grid.hostElement, e);
        }
    }

    onGridInitialized($event: any) {
    }
}
